function getUrlParam(param) {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get(param);
}

function initialize() {
    $('.page-sellers select[name="state"]').on('change', function () {
        const category = $(".page-sellers select[name='category'] option:selected").val();
        goRepresentantes(category, $(this).val());
    });

    $('.page-sellers select[name="country"]').on('change', function () {
        const category = $(".page-sellers select[name='category'] option:selected").val();
        goRepresentantes(category, $(this).val());
    });

    $('.page-sellers select[name="category"]').on('change', function () {
        const category = $(this).find('option:selected').val();
        goRepresentantes(category);
    });
}

function goRepresentantes(category, ufOrCountry) {
    let url = '/servicos/representantes-comerciais';

    if (category) {
        url += '/' + category;
    }

    if (ufOrCountry) {
        url += '/' + ufOrCountry;
    }

    // Pega o rep da URL, se existir
    let rep = getUrlParam('rep');
    if (!rep) {
        // Se não existir, gera um novo
        rep = Math.random().toString(36).substring(2, 10);
    }

    window.location = url + '?rep=' + rep + '#representantes';
}

initialize();